export const APPLICATION_TITLE_ES = 'Todo sobre {tag} | Mercado Libre';
export const APPLICATION_TITLE_PT = 'Tudo sobre {tag} | Mercado Libre';
export const UI_STYLE_PREFIX = 'seo-blog';
export const UI_LANDING_STYLE_PREFIX = 'seo-landing';
export const SCOPE_QUERY_PARAM = 'scope';
